module.exports = __webpack_public_path__ + "static/media/img_scan.1e26b728.svg";